// Main application logic for Vercel CDN

// Configuration
const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001';
const CDN_BASE_URL = import.meta.env.VITE_CDN_BASE_URL || API_URL;
const MAX_UPLOAD_SIZE = parseInt(import.meta.env.VITE_MAX_UPLOAD_SIZE || 10485760); // 10MB default

// DOM Elements
const dropArea = document.getElementById('drop-area');
const fileInput = document.getElementById('file-input');
const uploadButton = document.getElementById('upload-button');
const uploadProgress = document.getElementById('upload-progress');
const filesContainer = document.getElementById('files-container');

// File storage
let selectedFiles = [];

// Event Listeners
dropArea.addEventListener('dragover', (e) => {
  e.preventDefault();
  dropArea.classList.add('active');
});

dropArea.addEventListener('dragleave', () => {
  dropArea.classList.remove('active');
});

dropArea.addEventListener('drop', (e) => {
  e.preventDefault();
  dropArea.classList.remove('active');
  
  if (e.dataTransfer.files.length) {
    handleFiles(e.dataTransfer.files);
  }
});

fileInput.addEventListener('change', () => {
  if (fileInput.files.length) {
    handleFiles(fileInput.files);
  }
});

uploadButton.addEventListener('click', uploadFiles);

// Functions
function handleFiles(files) {
  selectedFiles = Array.from(files);
  uploadButton.disabled = selectedFiles.length === 0;
  
  // Preview selected files
  uploadProgress.innerHTML = `${selectedFiles.length} file(s) selected`;
}

async function uploadFiles() {
  if (selectedFiles.length === 0) return;
  
  uploadButton.disabled = true;
  uploadProgress.innerHTML = 'Uploading...';
  
  try {
    // Create FormData object to send files
    const formData = new FormData();
    
    // Add each file to the form data
    selectedFiles.forEach(file => {
      formData.append('files', file);
    });
    
    // Send files to the server
    const response = await fetch(`${API_URL}/api/upload`, {
      method: 'POST',
      body: formData,
    });
    
    if (!response.ok) {
      throw new Error(`Upload failed with status: ${response.status}`);
    }
    
    const result = await response.json();
    console.log('Upload successful:', result);
    
    // Display uploaded files
    displayUploadedFiles(result.files);
    
    // Reset state
    selectedFiles = [];
    fileInput.value = '';
    uploadProgress.innerHTML = `Upload complete! ${result.files.length} file(s) uploaded.`;
  } catch (error) {
    console.error('Upload failed:', error);
    uploadProgress.innerHTML = `Upload failed: ${error.message || 'Please try again'}`;
  } finally {
    uploadButton.disabled = false;
  }
}

function displayUploadedFiles(files) {
  files.forEach(file => {
    const fileElement = document.createElement('div');
    fileElement.className = 'file-item';
    
    // Get the CDN URL from the server response
    // For production, use the CDN_BASE_URL
    const cdnPath = file.cdnUrl || file.path;
    const cdnUrl = cdnPath.startsWith('http') ? cdnPath : `${CDN_BASE_URL}${cdnPath}`;
    const fileName = file.originalName || file.filename;
    const fileSize = file.size;
    
    // Create file preview based on type
    if (file.mimetype && file.mimetype.startsWith('image/')) {
      fileElement.innerHTML = `
        <div class="file-preview">
          <img src="${cdnUrl}" alt="${fileName}">
        </div>
        <div class="file-info">
          <p class="file-name">${fileName}</p>
          <p class="file-size">${formatFileSize(fileSize)}</p>
          <p class="cdn-url">CDN URL: <a href="${cdnUrl}" target="_blank">${cdnUrl}</a></p>
        </div>
      `;
    } else {
      const extension = getFileExtension(fileName);
      fileElement.innerHTML = `
        <div class="file-preview file-icon">
          <span>${extension}</span>
        </div>
        <div class="file-info">
          <p class="file-name">${fileName}</p>
          <p class="file-size">${formatFileSize(fileSize)}</p>
          <p class="cdn-url">CDN URL: <a href="${cdnUrl}" target="_blank">${cdnUrl}</a></p>
        </div>
      `;
    }
    
    filesContainer.appendChild(fileElement);
  });
}

function formatFileSize(bytes) {
  if (bytes === 0) return '0 Bytes';
  
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
}

function getFileExtension(filename) {
  return filename.split('.').pop().toUpperCase();
}

// Initialize - fetch and display any existing files
async function initializeApp() {
  try {
    // Fetch existing files from the server
    const response = await fetch(`${API_URL}/api/files`);
    
    if (!response.ok) {
      throw new Error(`Failed to fetch files: ${response.status}`);
    }
    
    const data = await response.json();
    
    if (data.files && data.files.length > 0) {
      // Display existing files
      displayUploadedFiles(data.files);
      console.log(`Loaded ${data.files.length} existing files`);
    } else {
      console.log('No existing files found');
    }
  } catch (error) {
    console.error('Error loading files:', error);
  }
}

// Start the app
initializeApp();
